import * as React from 'react';
import CandidatePronunciationRecorder from 'candidate_availability/candidate_pronunciation_recorder';
import CandidatePronounsField from 'candidate_availability/candidate_pronouns_field';
import Footer from './footer';
import styled from 'styled-components';

import type { Props as FooterProps } from './footer';
import type { CandidatePronouns, CandidatePronunciation } from '../../types';
import { BrandedPronunciationRecorder } from '../../../candidate_availability/branded/branded_pronunciation_recorder';
import { BrandedPronounsField } from '../../../candidate_availability/branded/branded_pronouns_field';

type Props = {
  candidatePronunciation: CandidatePronunciation;
  candidatePronouns: CandidatePronouns;
  isMobile: boolean;
  footer: FooterProps;
  children?: React.ReactNode;
  bonsaiEnabled?: boolean;
};

const AdditionalDetails = (props: Props) => {
  const {
    bonsaiEnabled,
    candidatePronunciation,
    candidatePronouns,
    isMobile,
    footer,
  } = props;

  const PronounsField = bonsaiEnabled
    ? BrandedPronounsField
    : CandidatePronounsField;

  const PronunciationRecorder = bonsaiEnabled
    ? BrandedPronunciationRecorder
    : CandidatePronunciationRecorder;

  return (
    <Container>
      {candidatePronunciation.display && (
        <PronunciationRecorder
          recordingName={candidatePronunciation.recordingName}
          recordingUrl={candidatePronunciation.recordingUrl}
        />
      )}
      {candidatePronouns.display && (
        <PronounsField
          pronouns={candidatePronouns.pronouns}
          defaultPronounsOptions={candidatePronouns.defaultPronounsOptions}
          isMobile={isMobile}
        />
      )}
      {props.children}
      <Footer {...footer} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media only screen and (max-width: 1024px) {
    margin: 35px auto 10px;
    padding: 0 60px;
  }

  @media only screen and (max-width: 480px) {
    padding: 0 35px;
  }
`;

export default AdditionalDetails;
